import React from "react";

const MongooseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 255.995 255.995"
    >
      <g
        fill="#b71c1c"
        strokeMiterlimit="10"
        fontFamily="none"
        fontSize="none"
        fontWeight="none"
        textAnchor="none"
        style={{ mixBlendMode: "normal" }}
      >
        <path
          d="M18.001 29.994V35l3.994-.005v-4.996l-1.994 2.005z"
          transform="scale(5.33333)"
        ></path>
        <path
          d="M46.586 21.441c-.177-.221-.84-.354-.84-.354l-.796 1.592.088-1.769s-4.821-1.946-8.668-2.875c-3.847-.929-6.58-1.291-8.048-1.326-1.062-.026-3.097.088-3.097.088l1.725 1.636s-2.167-.885-2.963-1.194c-.796-.309-2.034-.31-2.654-.354-.619-.044-1.15.221-1.15.221s-.575.442.752 3.405c1.088 2.43 3.719 3.965 4.632 4.44-5.917-1.284-6.578-7.005-6.578-7.005s-3.603-.037-8.757 1.769C4.408 21.756.944 25.686.944 25.686s4.6-1.548 8.492-.487c3.892 1.061 5.497 3.788 5.497 3.788l.107-3.007h2.936l2.251 2.713 1.758-2.677h2.971l.036-.001v5.979s2.014-1.665 3.372-2.328c1.813-.885 6.015-.619 6.015-.619s-.067-.47-.315-.967c-.352-.704.573-.935.573-.935s8.278-1.813 9.206-1.99c.929-.177 1.592-.575 1.813-.796.221-.221.84-1.769.973-1.946.134-.176.134-.751-.043-.972zM21.2 18.389c.221-.354.885-.487 1.902 0 1.2.574 2.654 2.477 2.654 2.477l-1.238-.575.619 1.106-1.106-.619.973 1.415-.663-.177.885 1.459c-3.849-2.211-4.247-4.732-4.026-5.086zm16.718 2.167l-.663.486s-2.654.354-3.361.31c-.708-.044-1.15-1.106-1.15-1.106l-1.459-.885zm-4.998 6.192c-.487.398-.044 1.371-.044 1.371-.663-.486-1.46-1.415-.752-1.946.708-.531 5.882-1.194 5.882-1.194s-4.6 1.371-5.086 1.769z"
          transform="scale(5.33333)"
        ></path>
      </g>
    </svg>
  );
};

export default MongooseIcon;
